import { t } from '../i18n';

const TERMS = [
  'mangel',
  'minderwert',
  'minderung',
  'technischerMinderwert',
  'optischerMinderwert',
  'geltungswert',
  'gebrauchswert',
  'merkantilerMinderwert',
  'zeitwert',
  'nachbesserungskosten',
  'nutzwerterfuellung',
  'wertrelation',
  'anspruchsszenario',
  'evidenzstufe',
  'expositionsgrad',
  'erwartungsklasse',
];

/** Glossar (Auftrag 13.2) — verbindliche Terminologie im UI hinterlegt. */
export function GlossaryPage() {
  return (
    <>
      <h1>{t('glossary.title')}</h1>
      <div className="karte">
        <dl>
          {TERMS.map((term) => (
            <div key={term} style={{ marginBottom: '0.9rem' }}>
              <dt>
                <strong>{t(`glossary.${term}.term`)}</strong>
              </dt>
              <dd style={{ margin: '0.15rem 0 0' }}>{t(`glossary.${term}.def`)}</dd>
            </div>
          ))}
        </dl>
      </div>
    </>
  );
}
